import { FormattedMessage } from 'react-intl';

const NoGiftBoxProductsSearchResult = (): JSX.Element => {
    return (
        <div className="d-flex flex-column mb-4x mt-xs-3x">
            <p className="theme-text-subtitle-text">
                <FormattedMessage defaultMessage="Deine Suche hat leider keine Treffer ergeben." />
            </p>

            <p className="theme-text-subtitle-text mt-2x">
                <FormattedMessage defaultMessage="Tipps:" />
            </p>

            <ul className="mt-1x">
                <li>
                    <FormattedMessage defaultMessage="Erweitere den Umkreis Radius" />
                </li>
                <li>
                    <FormattedMessage defaultMessage="Versuch es mit einer anderen Stadt" />
                </li>
            </ul>
        </div>
    );
};

export { NoGiftBoxProductsSearchResult };
